export default __webpack_public_path__ + "83c43cbfd3982b42af06d22f2642c8ca.png";